/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Col, Label, Alert, Button, Row, Collapse, InputGroup,
} from 'reactstrap';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import {
  Formik, Field, Form, ErrorMessage, FieldArray,
} from 'formik';
import * as Yup from 'yup';
import { isNull } from 'lodash';
import { post } from '../../helpers/api_helper';
import * as url from '../../helpers/url_helper';

function ContactForm(props) {
  const { entity, t } = props;

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isOpen, setIsOpen] = useState(0);

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const open = (ind) => {
    if (isOpen === ind) {
      setIsOpen(-1);
    } else {
      setIsOpen(ind);
    }
  };

  const save = async (values) => {
    try {
      setLoading(true);
      const result = await post(url.POST_DIRECTORY_ENTRY, values);
      setErrorMessage(null);

      toastr.success(`${entity.name} saved`, 'Success');
      props.onSuccess(result);
    } catch (error) {
      setErrorMessage(`${error.message}: ${error.response.data}`);
    } finally {
      setLoading(false);
    }
  };

  const ValidationSchema = Yup.object().shape({
    name: Yup
      .string()
      .required(props.t('Name is required')),
  });

  let em = (
    <Alert color="danger" className="mt-3" isOpen={!isNull(errorMessage)}>
      {errorMessage}
    </Alert>
  );

  if (errorMessage != null) { // Make part bold
    const match = errorMessage.match(/(.*)<<<(.+)>>>(.*)/);

    if (match !== null) {
      em = (
        <Alert color="danger" className="mt-3" isOpen>
          {match[1]}
          <strong>{match[2]}</strong>
          {match[3]}
        </Alert>
      );
    }
  }

  const handleAddAddress = (arrayHelpers, values) => {
    arrayHelpers.push({
      label: 'New Address',
      first_name: entity.name.split(' ')[0],
      last_name: entity.name.split(' ').length > 1 ? entity.name.split(' ')[1] : '',
      company: entity.company,
      email: entity.email,
      address_line_1: '',
      address_line_2: '',
      city: '',
      region: '',
      postcode: '',
      country_code: 'US',
      phone: entity.phone,
    });

    setIsOpen(values.addresses.length);
  };

  const jsx = (
    <>
      { em }
      <Formik
        enableReinitialize
        initialValues={entity}
        validationSchema={ValidationSchema}
        onSubmit={(values) => {
          save(values);
        }}
      >
        {({
          touched, errors, values,
        }) => (
          <Form className="mt-3" id="ItemEditForm" autoComplete="off">
            <Row>
              <Col xxl="6">
                <h6>{t('Details')}</h6>
                <div className="row mt-4 mb-4">
                  <Label
                    for="name"
                    className="col-sm-3 col-form-label"
                  >
                    {props.t('Name')}
                  </Label>
                  <Col sm={9}>
                    <Field
                      type="text"
                      className={`form-control ${(errors.name && touched.name ? 'is-invalid' : '')}`}
                      id="name"
                      name="name"
                    />
                    <ErrorMessage
                      name="name"
                      component="div"
                      className="invalid-feedback"
                    />
                  </Col>
                </div>

                <div className="row mt-4 mb-4">
                  <Label
                    for="name"
                    className="col-sm-3 col-form-label"
                  >
                    {props.t('Company')}
                  </Label>
                  <Col sm={9}>
                    <Field
                      type="text"
                      className={`form-control ${(errors.company && touched.company ? 'is-invalid' : '')}`}
                      id="company"
                      name="company"
                    />
                    <ErrorMessage
                      name="company"
                      component="div"
                      className="invalid-feedback"
                    />
                  </Col>
                </div>

                <div className="row mt-4 mb-4">
                  <Label
                    for="email"
                    className="col-sm-3 col-form-label"
                  >
                    {props.t('Email')}
                  </Label>
                  <Col sm={9}>
                    <Field
                      type="text"
                      className={`form-control ${(errors.email && touched.email ? 'is-invalid' : '')}`}
                      id="email"
                      name="email"
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="invalid-feedback"
                    />
                  </Col>
                </div>

                <div className="row mt-4 mb-4">
                  <Label
                    for="phone"
                    className="col-sm-3 col-form-label"
                  >
                    {props.t('Phone')}
                  </Label>
                  <Col sm={9}>
                    <Field
                      type="text"
                      className={`form-control ${(errors.phone && touched.phone ? 'is-invalid' : '')}`}
                      id="phone"
                      name="phone"
                    />
                    <ErrorMessage
                      name="phone"
                      component="div"
                      className="invalid-feedback"
                    />
                  </Col>
                </div>

                <div className="row mt-4 mb-4">
                  <Label
                    for="notes"
                    className="col-sm-3 col-form-label"
                  >
                    {props.t('Notes')}
                  </Label>
                  <Col sm={9}>
                    <Field
                      as="textarea"
                      className="form-control"
                      id="notes"
                      name="notes"
                    />
                    <ErrorMessage
                      name="notes"
                      component="div"
                      className="invalid-feedback"
                    />
                  </Col>
                </div>
                <Button type="submit" className="btn btn-primary">{t('Save')}</Button>
              </Col>
              <Col xxl="6">
                <FieldArray name="addresses" className="mt-3">
                  {(arrayHelpers) => (
                    <div>
                      <Button type="button" className="btn btn-sm btn-info float-end" onClick={() => { handleAddAddress(arrayHelpers, values); }}>
                        <span className="mdi mdi-plus" />
                        <span>{t('Add Address')}</span>
                      </Button>
                      <h6>{t('Addresses')}</h6>
                      <div className="accordion accordion-flush mt-3">
                        {values.addresses.map((x, i) => (
                          <div key={i} className="accordion-item">
                            <h2
                              className="accordion-header"
                            >
                              <button
                                className="accordion-button fw-medium"
                                type="button"
                                onClick={() => { open(i); }}
                                style={{ cursor: 'pointer' }}
                              >
                                {x.label}
                              </button>
                            </h2>
                            <Collapse
                              isOpen={isOpen === i}
                              className="accordion-collapse"
                            >
                              <div className="accordion-body">
                                <div className="row mt-4 mb-4">
                                  <Label
                                    for={`address_${i}_label`}
                                    className="col-sm-3 col-form-label"
                                  >
                                    {props.t('Address Label')}
                                  </Label>
                                  <Col sm={9}>
                                    <InputGroup>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        id={`address_${i}_label`}
                                        name={`addresses[${i}].label`}
                                      />
                                      <Button color="danger" className="btn-sm btn-soft-danger" onClick={() => arrayHelpers.remove(i)}>
                                        <span className="mdi mdi-close-thick" />
                                      </Button>
                                    </InputGroup>
                                    <ErrorMessage
                                      name={`addresses[${i}].label`}
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </Col>
                                </div>

                                <div className="row mt-4 mb-4">
                                  <Col sm="6">
                                    <Label
                                      for={`address_${i}_first_name`}
                                    >
                                      {props.t('First Name')}
                                    </Label>
                                    <Field
                                      type="text"
                                      className="form-control"
                                      id={`address_${i}_first_name`}
                                      name={`addresses[${i}].first_name`}
                                    />
                                    <ErrorMessage
                                      name={`addresses[${i}].first_name`}
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </Col>

                                  <Col sm="6">
                                    <Label
                                      for={`address_${i}_last_name`}
                                    >
                                      {props.t('Last Name')}
                                    </Label>
                                    <Field
                                      type="text"
                                      className="form-control"
                                      id={`address_${i}_last_name`}
                                      name={`addresses[${i}].last_name`}
                                    />
                                    <ErrorMessage
                                      name={`addresses[${i}].last_name`}
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </Col>
                                </div>

                                <div className="row mt-4 mb-4">
                                  <Label
                                    for={`address_${i}_company`}
                                    className="col-sm-3 col-form-label"
                                  >
                                    {props.t('Company')}
                                  </Label>
                                  <Col sm={9}>
                                    <Field
                                      type="text"
                                      className="form-control"
                                      id={`address_${i}_company`}
                                      name={`addresses[${i}].company`}
                                    />
                                    <ErrorMessage
                                      name={`addresses[${i}].company`}
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </Col>
                                </div>

                                <div className="row mt-4 mb-4">
                                  <Label
                                    for={`address_${i}_email`}
                                    className="col-sm-3 col-form-label"
                                  >
                                    {props.t('Email')}
                                  </Label>
                                  <Col sm={9}>
                                    <Field
                                      type="text"
                                      className="form-control"
                                      id={`address_${i}_email`}
                                      name={`addresses[${i}].email`}
                                    />
                                    <ErrorMessage
                                      name={`addresses[${i}].email`}
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </Col>
                                </div>

                                <div className="row mt-4 mb-4">
                                  <Col sm="12">
                                    <Label
                                      for={`address_${i}_address_line_1`}
                                    >
                                      {props.t('Address Lines')}
                                    </Label>
                                    <Field
                                      type="text"
                                      className="form-control mb-2"
                                      id={`address_${i}_address_line_1`}
                                      name={`addresses[${i}].address_line_1`}
                                    />
                                    <ErrorMessage
                                      name={`addresses[${i}].address_line_1`}
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                    <Field
                                      type="text"
                                      className="form-control"
                                      id={`address_${i}_address_line_2`}
                                      name={`addresses[${i}].address_line_2`}
                                    />
                                  </Col>
                                </div>

                                <div className="row mt-4 mb-4">
                                  <Col sm="5">
                                    <Label
                                      for={`address_${i}_city`}
                                    >
                                      {props.t('City')}
                                    </Label>
                                    <Field
                                      type="text"
                                      className="form-control"
                                      id={`address_${i}_city`}
                                      name={`addresses[${i}].city`}
                                    />
                                    <ErrorMessage
                                      name={`addresses[${i}].city`}
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </Col>

                                  <Col sm="3">
                                    <Label
                                      for={`address_${i}_region`}
                                    >
                                      {props.t('Region')}
                                    </Label>
                                    <Field
                                      type="text"
                                      className="form-control"
                                      id={`address_${i}_region`}
                                      name={`addresses[${i}].region`}
                                    />
                                    <ErrorMessage
                                      name={`addresses[${i}].region`}
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </Col>

                                  <Col sm="3">
                                    <Label
                                      for={`address_${i}_postcode`}
                                    >
                                      {props.t('Zip')}
                                    </Label>
                                    <Field
                                      type="text"
                                      className="form-control"
                                      id={`address_${i}_postcode`}
                                      name={`addresses[${i}].postcode`}
                                    />
                                    <ErrorMessage
                                      name={`addresses[${i}].postcode`}
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </Col>
                                </div>

                                <div className="row mt-4 mb-4">
                                  <Col sm="4">
                                    <Label
                                      for={`address_${i}_country_code`}
                                    >
                                      {props.t('Country Code')}
                                    </Label>
                                    <Field
                                      type="text"
                                      className="form-control"
                                      id={`address_${i}_country_code`}
                                      name={`addresses[${i}].country_code`}
                                    />
                                    <ErrorMessage
                                      name={`addresses[${i}].country_code`}
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </Col>

                                  <Col sm="8">
                                    <Label
                                      for={`address_${i}_phone`}
                                    >
                                      {props.t('Phone')}
                                    </Label>
                                    <Field
                                      type="text"
                                      className="form-control"
                                      id={`address_${i}_phone`}
                                      name={`addresses[${i}].phone`}
                                    />
                                    <ErrorMessage
                                      name={`addresses[${i}].phone`}
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </Col>
                                </div>
                              </div>
                            </Collapse>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </FieldArray>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );

  return jsx;
}

ContactForm.defaultProps = {
  entity: {
    id: '',
    name: '',
    company: '',
    phone: '',
    email: '',
    addresses: [],
    notes: '',
  },
  onSuccess: () => {},
  t: (x) => (x),
};

ContactForm.propTypes = {
  t: PropTypes.any,
  entity: PropTypes.object,
  onSuccess: PropTypes.func,
};

export default connect(() => ({

}), {})(withTranslation()(ContactForm));
